import AntIcon from "@/components/icons/AntIcon";
import { Alert, Button, Card, Flex } from "antd";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  title: ReactNode;
  isChanged: boolean;
  discounts?: ReactNode;
  onRecalculate: () => void;
  children: ReactNode;
};

export const CalcRecalculationCard = ({ title, isChanged, discounts, onRecalculate, children }: Props) => {
  const { t } = useTranslation();

  return (
    <Card
      className="card-box"
      title={<h3 style={{ marginBottom: 0 }}>{title}</h3>}
      extra={
        <Flex gap="middle" align="center">
          {isChanged && (
            <Alert
              type="warning"
              showIcon
              title={t("calc.helpers.notRecalculatedChanges")}
              style={{ padding: "4px 12px" }}
            />
          )}

          {discounts}

          <Button type="primary" icon={<AntIcon type="calculator" />} onClick={onRecalculate}>
            {t("common.recalculate")}
          </Button>
        </Flex>
      }
    >
      <Flex wrap gap="small">
        {children}
      </Flex>
    </Card>
  );
};
